module.exports = __webpack_public_path__ + "img/s2P9.1f9214da.png";